import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { Providers } from './app/providers';
import './styles/globals.css';

// Apply persisted theme/dir before paint to avoid flash.
try {
  const theme = localStorage.getItem('elshahd_theme');
  if (theme === 'dark') document.documentElement.classList.add('dark');
} catch {
  /* ignore */
}

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

createRoot(container).render(
  <StrictMode>
    <Providers>
      <App />
    </Providers>
  </StrictMode>,
);
